'use client'
import React from 'react'
import styles from './styles.module.scss'
import { Game } from '@l2p/game-api'
import { DesktopGameCard, MobileGameCard } from '../GameCard'
import { useBreakpoint } from '@l2p/apps-shared'
import { POPUP_CONSTANTS } from '@l2p/apps-shared'

interface SlideProps {
  games: Game[]
  title?: string
  slider: any
  cuntSlides: number
  cardsInSlide: number
  gameCardPlaceholder: string
}

const Slide: React.FC<SlideProps> = ({
  games,
  title,
  slider,
  cardsInSlide,
  gameCardPlaceholder,
}) => {
  const breakpoints = useBreakpoint()
  return (
    <div className={styles.slideWrapper}>
      {!breakpoints.mobile && !breakpoints.tablet && (
        <div
          className={`${styles.arrow} ${styles.prev}`}
          onClick={() => slider?.current?.slidePrev()}
        />
      )}
      <div
        className={styles.slideContainer}
        style={{ gridTemplateColumns: `repeat(${cardsInSlide}, 1fr)` }}
      >
        {games.map((game, idx) => (
          <React.Fragment key={`game_slider_slide_${idx}_${title}`}>
            {breakpoints.tablet || breakpoints.mobile ? (
              <MobileGameCard
                gameId={game.id}
                title={game.title}
                slug={game?.slug}
                gameCardPlaceholder={gameCardPlaceholder}
                gameInfoModalKey={POPUP_CONSTANTS.GAME_INFO_MODAL}
              />
            ) : (
              <DesktopGameCard
                gameId={game.id}
                withDemo={game?.settings?.['demo']}
                title={game.title}
                slug={game.slug}
                gameCardPlaceholder={gameCardPlaceholder}
                signUpModalKey={POPUP_CONSTANTS.SIGN_UP_MODAL}
              />
            )}
          </React.Fragment>
        ))}
      </div>
      {!breakpoints.mobile && !breakpoints.tablet && (
        <div
          className={`${styles.arrow} ${styles.next}`}
          onClick={() => slider?.current?.slideNext()}
        />
      )}
    </div>
  )
}

export default Slide
